import { useMemo } from 'react';
import { useEngine } from '../api/context';
import { useEntitlements } from '../meta/useEntitlements';
import { useDataSource } from '../meta/useDataSource';
import { mergeNav, buildAreas } from './areas';

/**
 * The nav this viewer may use, in one place for every surface that lists destinations (the
 * sidebar, the Home hub): modules the tenant's plan licenses, and — for a tenant running on its
 * connected system (Halo overlay) — only the screens that system backs plus NovaPSA's own shell
 * (src/engine/meta/useDataSource.ts). Routes stay complete, so a deep link still resolves and the
 * API is the real gate.
 */
export function useNavSections() {
  const { modules } = useEngine();
  const { isVisible } = useEntitlements();
  const visibleModules = useMemo(() => modules.filter((m) => isVisible(m.name)), [modules, isVisible]);
  const { overlay, isServed } = useDataSource();
  const sections = useMemo(() => {
    const merged = mergeNav(visibleModules);
    if (!overlay) return merged;
    return merged.map((s) => ({ ...s, items: s.items.filter((i) => isServed(i.to)) })).filter((s) => s.items.length > 0);
    // isServed is derived from overlay
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visibleModules, overlay]);
  const areas = useMemo(() => buildAreas(sections), [sections]);
  return { sections, areas };
}
